/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {inject, Injectable} from '@angular/core';
import {APP_CONFIG} from '../app.config';
import {UserInfo} from "../model/user-info";
import {HttpClient} from "@angular/common/http";


@Injectable()
export class AppLoadService {
  private _userInfoUrl;
  private _user: UserInfo;

  constructor(private http: HttpClient) {
    this._userInfoUrl = inject(APP_CONFIG).baseUrl + '/api/userinfo';
  }

  getUserInfo(): Promise<UserInfo> {
    const promise = this.http.get(this._userInfoUrl)
      .toPromise()
      .then(user => {
        this._user = user as UserInfo;
        sessionStorage.gmid = this._user.gmid;
        sessionStorage.gmin = this._user.gmin;
        sessionStorage.isSiteAdmin = this._user.roles.indexOf("PGA_SiteAdmin") >= 0;
        sessionStorage.isSuperAdmin = this._user.roles.indexOf("PGA_Admin") >= 0;
        sessionStorage.siteAdminRoles = this._user.roles.filter(x=>!x.indexOf("PGA_SiteAdmin_"));

        return this._user;
      });

    return promise;
     // return  null;
  }


}
